var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Suspense, useState, useEffect, lazy } from "react";
import { useNavigate } from 'react-router-dom';

import Targets from './targets';
import NotFound from './notfound';

var PagesPath = 'pages';
var SuspenseFallback = undefined;
var MainNavs = undefined;
var SelectedMainNavIdx = -1,
    SelectedMainNavChildIdx = -1;
var MainTabs = [];
var ActiveMainTabIdx = -1;
var IsRemoveMainTabBacking = undefined;
var PopTabs = [];
var TabZIndex = 1000;

// const DataKey = '__react_admin_core__';
// let SavedData = localStorage.getItem(DataKey);
// if(SavedData) {
//     try{
//         SavedData = JSON.parse(SavedData);
//     } catch(ex) {
//         SavedData = {};
//     }
// } else {
//     SavedData = {};
// }

// const SaveData = () => {
//     localStorage.setItem(DataKey, JSON.stringify(SavedData));
// };

var SetAuthed = undefined;
var SetOpenedPopTabs = undefined;
var RemoveMainTab = undefined;
var ClosePopTab = undefined;

var GenTab = function GenTab(ops) {
    var tab = {
        route: ops.newRoute,
        target: ops.target,
        size: ops.size,
        options: {},
        zIndex: TabZIndex++,
        dt: Date.now(),
        setOptions: function setOptions(options) {
            if (options) {
                for (var k in options) {
                    tab.options[k] = options[k];
                }
                if (tab._setOptions) {
                    tab._setOptions(options);
                }
                if (tab._setOptions1) {
                    tab._setOptions1(options);
                }
            }
        }
    };

    if (ops.title === undefined) {
        if (tab.route) {
            if (MainNavs && SelectedMainNavIdx >= 0) {
                var navItem = MainNavs[SelectedMainNavIdx];
                if (navItem) {
                    if (SelectedMainNavChildIdx >= 0) {
                        navItem = navItem.childs[SelectedMainNavChildIdx];
                    }
                    if (navItem && navItem.url === tab.route.url) {
                        tab.options.title = navItem.title;
                    }
                }
            }
        }
        if (!tab.options.title) {
            tab.options.title = tab.route.name;
        }
    } else {
        tab.options.title = ops.title;
    }

    if (ops.content) {
        tab.ele = ops.content;
    } else if (tab.route) {
        var aryPName = tab.route.name.split('-');

        // let Ele = lazy(() => import('../../src/pages/' + aryPName.join('/')));
        var Ele = lazy(function () {
            var p = import('../../src/' + PagesPath + '/' + aryPName.join('/'));
            // let p = import('../' + PagesPath + '/' + aryPName.join('/'));
            p.then(function (T) {
                if (T.default.options) {
                    for (var k in T.default.options) {
                        tab.options[k] = T.default.options[k];
                    }
                }
            });
            return p;
        });
        tab.ele = React.createElement(
            NotFound,
            { route: tab.route },
            React.createElement(
                Suspense,
                { fallback: SuspenseFallback || React.createElement(
                        'span',
                        null,
                        'Loading.....'
                    ) },
                React.createElement(Ele, { newRoute: tab.route, oldRoute: ops.oldRoute,
                    $setOptions: tab.setOptions,
                    $getBtns: function $getBtns() {
                        return tab._btns;
                    }
                    // openedPopTabs={openedPopTabs}
                    // $setOpenedPopTabs={setOpenedPopTabs}
                    , $setAuthed: SetAuthed,
                    $close: function $close() {
                        if (tab.target === Targets._right || tab.target === Targets._dialog) {
                            ClosePopTab(tab);
                        } else {
                            RemoveMainTab(tab);
                        }
                    } })
            )
        );
    }

    if (ops.btns) {
        tab.options.btns = ops.btns;
    }

    if (tab.target === Targets._right || tab.target === Targets._dialog) {
        for (var i = PopTabs.length - 1; i >= 0; i--) {
            if (PopTabs[i].opened === false) {
                PopTabs.splice(i, 1);
            }
        }
        tab.hideClose = ops.hideClose;
        PopTabs.push(tab);
        setTimeout(function () {
            tab.opened = true;
            SetOpenedPopTabs(tab);
        }, 0);
    } else {
        MainTabs.push(tab);
    }

    return tab;
};

var Dialog = function Dialog(ops) {
    ops = ops || {};

    this.tab = GenTab({
        target: Targets._dialog,
        title: ops.title || '',
        content: ops.content || '',
        size: ops.size,
        btns: ops.btns,
        hideClose: ops.hideClose
    });

    return this;
};

Dialog.prototype.close = function () {
    ClosePopTab(this.tab);
};

Dialog.show = function (ops) {
    return new Dialog(ops);
};

Dialog.confirm = function (content, callbackFun, options) {
    var ops = {
        title: 'Confirm',
        content: content,
        size: 's',
        hideClose: true,
        btns: [{
            txt: 'Cancel',
            color: 'info',
            fn: function fn() {
                dg.close();
                if (callbackFun) {
                    callbackFun(false);
                }
            }
        }, {
            txt: 'Confirm',
            fn: function fn() {
                dg.close();
                if (callbackFun) {
                    callbackFun(true);
                }
            }
        }]
    };
    if (options) {
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            if (options.title) {
                ops.title = options.title;
            }
            if (options.cancelTxt) {
                ops.btns[0].txt = options.cancelTxt;
            }
            if (options.confirmTxt) {
                ops.btns[1].txt = options.confirmTxt;
            }
            if (options.size) {
                ops.size = options.size;
            }
        } else {
            ops.title = options;
        }
    }
    var dg = Dialog.show(ops);
    return dg;
};

Dialog.alert = function (content, callbackFun, options) {
    var ops = {
        title: 'Alert',
        content: content,
        size: 's',
        hideClose: true,
        btns: [{
            txt: 'I See',
            fn: function fn() {
                dg.close();
                if (callbackFun) {
                    callbackFun(true);
                }
            }
        }]
    };
    if (options) {
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            if (options.title) {
                ops.title = options.title;
            }
            if (options.btnTxt) {
                ops.btns[0].txt = options.btnTxt;
            }
            if (options.size) {
                ops.size = options.size;
            }
        } else {
            ops.title = options;
        }
    }
    var dg = Dialog.show(ops);
    return dg;
};

export { Dialog };

var CUREASYLAYOUT = null;

var EasyLayout = function EasyLayout(props) {
    var config = props.config || {};

    var _useState = useState(0),
        _useState2 = _slicedToArray(_useState, 2),
        authState = _useState2[0],
        setAuthState = _useState2[1];

    useEffect(function () {
        if (config.checkAuth) {
            config.checkAuth(function (isAuthed) {
                setAuthState(isAuthed ? 2 : 1);
            });
        } else {
            setAuthState(2);
        }
    }, []);

    var _useState3 = useState({}),
        _useState4 = _slicedToArray(_useState3, 2),
        openedPopTabs = _useState4[0],
        setOpenedPopTabs = _useState4[1];

    useEffect(function () {
        PopTabs.forEach(function (T) {
            if (openedPopTabs[T.dt]) {
                T.opened = true;
            } else if (openedPopTabs[T.dt] === false) {
                T.opened = false;
            }
        });
    }, [openedPopTabs]);

    SetOpenedPopTabs = function SetOpenedPopTabs(tabOpened) {
        setOpenedPopTabs(Object.assign({}, openedPopTabs, _defineProperty({}, tabOpened.dt + '', true)));
    };

    var navigate = useNavigate();

    var setAuthed = function setAuthed(authed) {
        setAuthState(authed ? 2 : 1);
    };
    SetAuthed = setAuthed;

    if (authState == 2) {
        PagesPath = config.pagesPath || 'pages';

        var mainNavs = config.mainNavs || [];
        MainNavs = mainNavs;

        SuspenseFallback = config.suspenseFallback;

        var removeMainTab = function removeMainTab(removedTab) {
            var removedTabIdx = MainTabs.findIndex(function (T) {
                return T.dt === removedTab.dt;
            });
            if (removedTabIdx >= 0) {
                MainTabs.splice(removedTabIdx, 1);
                if (removedTabIdx == ActiveMainTabIdx) {
                    if (MainTabs.length == 0) {
                        navigate('', { replace: true });
                    } else {
                        IsRemoveMainTabBacking = true;
                        navigate(-1);
                    }
                } else {
                    navigate(props.newRoute.url, { replace: true });
                }
            }
        };
        RemoveMainTab = removeMainTab;

        var closePopTab = function closePopTab(removedTab) {
            removedTab.opened = false;
            var obj = {},
                ks = Object.keys(openedPopTabs);
            for (var i = 0; i < ks.length - 1; i++) {
                if (openedPopTabs[ks[i]]) {
                    obj[ks[i]] = true;
                }
            }
            obj[removedTab.dt + ''] = false;
            setOpenedPopTabs(obj);
        };
        ClosePopTab = closePopTab;

        var mainNavIdx = -1,
            mainNavChildIdx = -1;
        for (var i = 0; i < mainNavs.length; i++) {
            var item = mainNavs[i];
            if (item.url === props.newRoute.url || item.url === props.newRoute.pathname) {
                mainNavIdx = i;
                break;
            }
            if (item.childs) {
                for (var j = 0; j < item.childs.length; j++) {
                    var child = item.childs[j];
                    if (child.url === props.newRoute.url || child.url === props.newRoute.pathname) {
                        mainNavIdx = i;
                        mainNavChildIdx = j;
                        break;
                    }
                }
            }
        }
        if (mainNavIdx >= 0) {
            SelectedMainNavIdx = mainNavIdx;
            SelectedMainNavChildIdx = mainNavChildIdx;
            if (mainNavs[mainNavIdx].childs) {
                if (!props.oldRoute) {
                    // if(!SavedData.openedMainNavs) {
                    //     SavedData.openedMainNavs = {};
                    // }
                    // SavedData.openedMainNavs[SelectedMainNavIdx + ''] = true;
                }
            }
        } else {
            if (!props.newRoute.url) {
                SelectedMainNavIdx = SelectedMainNavChildIdx = -1;
            }
        }

        if (props.newRoute.pathname) {
            var dt = Date.now();
            var target = props.newRoute.searchParams && props.newRoute.searchParams.__target__,
                genTab = function genTab() {
                return GenTab({
                    newRoute: props.newRoute,
                    oldRoute: props.oldRoute,
                    target: target,
                    size: props.newRoute.searchParams && props.newRoute.searchParams.__size__
                });
            };

            if (target === Targets._right || target === Targets._dialog) {
                IsRemoveMainTabBacking = undefined;
                if (PopTabs.length == 0 || dt - PopTabs[PopTabs.length - 1].dt >= 50) {
                    genTab();
                    navigate(-1);
                } else {
                    return CUREASYLAYOUT;
                }
            } else {
                var tabIdx = MainTabs.findIndex(function (T) {
                    return T.route.url === props.newRoute.url;
                });

                if (tabIdx >= 0) {
                    ActiveMainTabIdx = tabIdx;
                    IsRemoveMainTabBacking = undefined;
                } else {
                    if (IsRemoveMainTabBacking) {
                        ActiveMainTabIdx = false;
                        setTimeout(function () {
                            navigate(-1);
                        }, 0);
                        // return CUREASYLAYOUT;
                    } else {
                        genTab();
                        ActiveMainTabIdx = MainTabs.length - 1;
                        IsRemoveMainTabBacking = undefined;
                    }
                }
            }
        }

        CUREASYLAYOUT = React.createElement(
            Suspense,
            { fallback: config.suspenseFallback || React.createElement(
                    'span',
                    null,
                    'Loading.....'
                ) },
            React.createElement(config.layoutPage, Object.assign({}, props, { mainTabs: MainTabs, popTabs: PopTabs,
                selectedMainNavIdx: SelectedMainNavIdx,
                selectedMainNavChildIdx: SelectedMainNavChildIdx,
                activeMainTabIdx: ActiveMainTabIdx,
                openedPopTabs: openedPopTabs,
                closeMainTab: removeMainTab,
                closePopTab: closePopTab,
                $setAuthed: setAuthed }))
        );

        return CUREASYLAYOUT;
    } else if (authState == 1) {
        return React.createElement(
            Suspense,
            { fallback: config.suspenseFallback || React.createElement(
                    'span',
                    null,
                    'Loading.....'
                ) },
            React.createElement(config.loginPage, { config: config, $setAuthed: setAuthed })
        );
    } else {
        if (config.ing) {
            return React.createElement(
                Suspense,
                { fallback: config.suspenseFallback || React.createElement(
                        'span',
                        null,
                        'Loading.....'
                    ) },
                React.createElement(config.ing, null)
            );
        }
        return null;
    }
};

export default EasyLayout;